import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.scss']
})
export class QualityComponent {
  title = 'eunomiaaudit';
}
